import { render, staticRenderFns } from "./CarrierContactInfoEditor.vue?vue&type=template&id=bda3fe52&"
import script from "./CarrierContactInfoEditor.vue?vue&type=script&lang=js&"
export * from "./CarrierContactInfoEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports